import { colors } from '../base/colors'

export const buttons = {
  defaultProps: {
    disableRipple: true
  },
  styleOverrides: {
    root: {
      color: colors.white.main,
      fontFamily: 'Montserrat, sans-serif'
    },
    contained: {
      color: colors.white.main
    },
    containedSizeLarge: {
      fontSize: '18px'
    },
    containedSizeMedium: {
      fontSize: '16px',
      fontWeight: 500
    },
    containedSizeSmall: {
      fontSize: '12px',
      padding: '4px 10px'
    },
    containedInherit: {
      color: colors.text.primary,
      ['&:hover']: {
        backgroundColor: colors.text.primary,
        color: colors.white.main
      },
      ['&:active']: {
        color: colors.white.main,
        backgroundColor: colors.text.primary
      }
    },
    outlined: {
      color: colors.text.primary,
      ['&:hover']: {
        color: colors.white.main
      }
    },
    outlinedSizeLarge: {
      fontSize: '18px'
    },
    outlinedSizeMedium: {
      fontSize: '16px'
    },
    outlinedSizeSmall: {
      fontSize: '12px',
      padding: '4px 10px'
    },
    outlinedError: {
      ['&:hover']: {
        backgroundColor: colors.error.dark
      },
      ['&:active']: {
        backgroundColor: colors.error.active
      }
    },
    outlinedInfo: {
      ['&:hover']: {
        backgroundColor: colors.info.dark
      },
      ['&:active']: {
        backgroundColor: colors.info.active
      }
    },
    outlinedPrimary: {
      ['&:hover']: {
        backgroundColor: colors.primary.dark
      },
      ['&:active']: {
        backgroundColor: colors.primary.active
      }
    },
    outlinedSecondary: {
      ['&:hover']: {
        backgroundColor: colors.secondary.dark
      },
      ['&:active']: {
        backgroundColor: colors.secondary.active
      }
    },
    outlinedSuccess: {
      ['&:hover']: {
        backgroundColor: colors.success.dark
      },
      ['&:active']: {
        backgroundColor: colors.success.active
      }
    },
    outlinedWarning: {
      ['&:hover']: {
        backgroundColor: colors.warning.dark
      },
      ['&:active']: {
        backgroundColor: colors.warning.active
      }
    },
    outlinedInherit: {
      ['&:hover']: {
        backgroundColor: colors.text.primary
      },
      ['&:active']: {
        backgroundColor: colors.text.primary
      }
    },
    text: {
      color: colors.text.primary
    },
    textError: {
      color: colors.error.main
    },
    textInfo: {
      color: colors.info.main
    },
    textPrimary: {
      color: colors.primary.main
    },
    textSecondary: {
      color: colors.secondary.main
    },
    textSuccess: {
      color: colors.success.main
    },
    textWarning: {
      color: colors.warning.main
    },
    textInherit: {
      color: colors.text.primary
    },
    textSizeLarge: {
      fontSize: '18px'
    },
    textSizeMedium: {
      fontSize: '16px'
    },
    textSizeSmall: {
      fontSize: '12px',
      padding: '4px 10px'
    }
  }
}
